import { render, staticRenderFns } from "./EditInventorySession.vue?vue&type=template&id=479684a2"
import script from "./EditInventorySession.vue?vue&type=script&lang=js"
export * from "./EditInventorySession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports